import axios from "axios";

const setBearer = (bearerToken) => {
  if (bearerToken) {
  const token = bearerToken.replace(/^"+|"+$/g, "");
  axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    delete axios.defaults.headers.common["Authorization"];
  }
};

export default setBearer;
